import { compose } from 'recompose'
import { injectIntl } from 'react-intl'
import { withAdditionalInfoToggle } from 'src/composables'

const AdditionalInfoContainer = compose(
  withAdditionalInfoToggle,
  injectIntl
)

export default AdditionalInfoContainer
